import React, { useRef, useEffect } from "react";
import Legend from "@arcgis/core/widgets/Legend";
import { useStore } from "../../../stores/store";
export const LegendTab = () => {
  const { mapView } = useStore();
  const legendRef = useRef(null);
  const isLoaded = useRef(false);
  useEffect(() => {
    if (!mapView || !legendRef.current || isLoaded.current) {
      return;
    }
    new Legend({
      view: mapView,
      container: legendRef.current,
    });
    isLoaded.current = true;
  }, [mapView, legendRef.current]);

  return (
    <div className="mt-2 max-h-64 overflow-auto">
      <div ref={legendRef}></div>
    </div>
  );
};
